<div class="modal-header modal-block-primary">
  <h4 class="modal-title">{{ popupTitle }}</h4>
  <button type="button" class="close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span><span class="sr-only">{{"BUTTONS.CLOSE" | translate}}</span>
  </button>
</div>
<div class="modal-body clearfix">
  <div class="modal-icon">
  </div>
  <div class="modal-text">
    <p style="font-size: 14px;"><i class="far fa-question-circle"></i>{{ popupText }}</p>
  </div>
  @if (errorDetail) {
    <div class="modal-footer">
      <small>{{ errorDetail }}</small>
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-primary right" (click)="action(true)">{{"BUTTONS.CLOSE" | translate}}</button>
</div>